<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <app-content-title v-if="!newItem" :title="item.name" />
        <app-content-title v-if="newItem" :title="translations.newTvChannel" />
      </div>

      <app-settings @submit="onFormSubmit" :disabled="dataPending">
        <app-settings-content>
          <app-settings-desc :title="translations.basicInfo">
            <p>
              <translate>Založeno</translate>:<br />
              <span v-html="formatDateAdvanced(item._created)" />
            </p>
            <p>
              <translate>Poslední změna</translate>:<br />
              <span v-html="formatDateAdvanced(item._updated)" />
            </p>
            <app-image-input
                logo
                :force-title="true"
                pClass="profile_image_box"
                labelClass="profile_image logo"
                name="imgLogoDefault"
                :label-title="translations.logoDefault"
                :text="translations.uploadDefaultLogo"
                :vertical-layout="true"
                :image="channelFormItem.logoDefault"
                :imageLink="images.default.imageLogoLink"
                :disabled="dataPending"
                :error="errors.items.find(el => el.field === 'imgLogoDefault')"
                :deleting="images.default.imageDeleting"
                @fileChanged="onFileChanged('default')"
            />
            <app-image-input
              logo
              :force-title="true"
              pClass="profile_image_box"
              labelClass="profile_image logo"
              name="imgLogoColored"
              :label-title="translations.logoColored"
              :text="translations.uploadColoredLogo"
              :vertical-layout="true"
              :image="channelFormItem.logoColored"
              :imageLink="images.colored.imageLogoLink"
              :disabled="dataPending"
              :error="errors.items.find(el => el.field === 'imgLogoColored')"
              :deleting="images.colored.imageDeleting"
              @fileChanged="onFileChanged('colored')"
            />
            <app-image-input
              logo
              :force-title="true"
              pClass="profile_image_box"
              labelClass="profile_image logo"
              name="imgLogo720p"
              :label-title="translations.logo720p"
              :text="translations.upload720Logo"
              :vertical-layout="true"
              :image="channelFormItem.logo720p"
              :imageLink="images.p720.imageLogoLink"
              :disabled="dataPending"
              :error="errors.items.find(el => el.field === 'imgLogo720p')"
              :deleting="images.p720.imageDeleting"
              @fileChanged="onFileChanged('p720')"
            />
            <app-image-input
              logo
              :force-title="true"
              pClass="profile_image_box"
              labelClass="profile_image logo"
              name="imgLogo1080p"
              :label-title="translations.logo1080p"
              :text="translations.upload1080Logo"
              :vertical-layout="true"
              :image="channelFormItem.logo1080p"
              :imageLink="images.p1080.imageLogoLink"
              :disabled="dataPending"
              :error="errors.items.find(el => el.field === 'imgLogo1080p')"
              :deleting="images.p1080.imageDeleting"
              @fileChanged="onFileChanged('p1080')"
            />
              <h2 v-translate>Poslední import</h2>
              <p>
                  <translate>Datum</translate>:
                  <br />
                  <span v-html="formatDateAdvanced(item._lastImport)" />
              </p>
              <p>
                  <translate>Počet broadcastů</translate>
                  : {{ item._lastImportBroadcastsCount }}
              </p>
          </app-settings-desc>

          <app-settings-options>
            <app-settings-col class="field_left">
              <app-input
                  required
                  :label="translations.name"
                  :error="errors.items.find(el => el.field === 'name')"
                  v-model="channelFormItem.name"
                  name="name"
              />
            </app-settings-col>
            <app-settings-col class="field_right">
              <app-input
                  :label="translations.tvChannelId"
                  v-model="item._id"
                  disabled
              />
            </app-settings-col>

            <app-settings-col class="field_left">
              <app-settings-select
                :error="errors.items.find(el => el.field === 'countryId')"
                :label="translations.tvChannelCountry"
              >
                <app-select
                  name="countryId"
                  :options="countrySelect"
                  v-model="channelFormItem.countryId"
                  :disabled="isTvStationCountryDefined"
                />
              </app-settings-select>

              <app-settings-select
                  required
                  :error="errors.items.find(el => el.field === 'tvStation')"
                  :label="translations.tvStation"
              >
                <app-select
                    selectId="tvStation"
                    :options="tvStationsOptions"
                    v-model="channelFormItem.tvStation._id"
                    @change="selectTvStation"
                    name="tvStation"
                />
              </app-settings-select>
              <app-input
                  required
                  :label="translations.sanitizedId"
                  :error="errors.items.find(el => el.field === 'sanitizedId')"
                  v-model="channelFormItem.sanitizedId"
                  name="sanitizedId"
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.remoteId"
                  :error="errors.items.find(el => el.field === 'remoteId')"
                  v-model="channelFormItem.remoteId"
                  name="remoteId"
              />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-settings-select
                  required
                  :error="errors.items.find(el => el.field === 'channelCharacter')"
                  :label="translations.channelCharacter"
              >
                <app-select
                    selectId="channelCharacter"
                    :options="enums.tvChannelCharacter"
                    v-model="channelFormItem.channelCharacter"
                    name="channelCharacter"
                />
              </app-settings-select>
              <app-input
                  required
                  :label="translations.weight"
                  :error="errors.items.find(el => el.field === 'weight')"
                  type="number"
                  v-model="channelFormItem.weight"
                  name="weight"
              />
            </app-settings-col>

            <app-settings-col class="field_left">
              <app-settings-select
                  :error="errors.items.find(el => el.field === 'broadcastingFrom')"
                  :label="translations.broadcastingFrom"
              >
                <app-time-select
                  :value="channelFormItem.broadcastingFrom"
                  hourName="hourBroadcastingFrom"
                  minuteName="minuteBroadcastingFrom"
                />
              </app-settings-select>
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-settings-select
                  :error="errors.items.find(el => el.field === 'broadcastingTo')"
                  :label="translations.broadcastingTo"
              >
                <app-time-select
                  v-model="channelFormItem.broadcastingTo"
                  hourName="hourBroadcastingTo"
                  minuteName="minuteBroadcastingTo"
                />
              </app-settings-select>
            </app-settings-col>

            <app-settings-col class="field_left">
              <app-settings-select
                  required
                  :error="errors.items.find(el => el.field === 'videoQualityId')"
                  :label="translations.videoQuality"
              >
                <app-select
                    selectId="videoQualityId"
                    :options="videoQualities"
                    v-model="channelFormItem.videoQualityId"
                    name="videoQualityId"
                />
              </app-settings-select>
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-settings-control>
                <app-checkbox
                        name="active"
                        :title="translations.active"
                        v-model="channelFormItem.active"
                />
              </app-settings-control>
            </app-settings-col>

            <app-settings-input
                :error="errors.items.find(el => el.field === 'note')"
                :label="translations.note"
            >
              <app-textarea
                  v-model="channelFormItem.note"
                  name="note"
              />
            </app-settings-input>
          </app-settings-options>
        </app-settings-content>

        <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'tv-channels' }">
          <app-content-save-button :disabled="dataPending" @click="disallowBack" />
        </app-settings-buttons>
      </app-settings>
    </form>
  </app-content>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState } from 'vuex'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import { getCommonFormSubmit, setLoadingMessage, showErrorWithTimeout } from 'utils/form'
import formatDateMixin from 'mixins/formatDateMixin'
import { VUE_APP_BASE_API_URL } from 'constants/fileConstants'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'TvChannel',
  enums: true
})

export default {
  name: 'tv-channel',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  created() {
    this.getTvStationsOrderedByName()
    this.getCountriesOrderedByName()
    this.getVideoQualities()
    this.channelFormItem.name = this.$route.query.name
    this.channelFormItem.tvStation._id = parseInt(this.$route.query.tvStationId)
  },
  data() {
    return {
      images: {
        default: {
          imagesUploading: false,
          imageDeleting: false,
          channelLogoChanged: false,
          imageLogoLink: ''
        },
        colored: {
          imagesUploading: false,
          imageDeleting: false,
          channelLogoChanged: false,
          imageLogoLink: ''
        },
        p720: {
          imagesUploading: false,
          imageDeleting: false,
          channelLogoChanged: false,
          imageLogoLink: ''
        },
        p1080: {
          imagesUploading: false,
          imageDeleting: false,
          channelLogoChanged: false,
          imageLogoLink: ''
        }
      },
      tvStationId: null
    }
  },
  computed: {
    ...mapState({
      tvStationsOptions: (state, vm) => {
        return [
          {
            value: null,
            name: 'Neurčeno',
            country: null
          },
          ...state.tvStations.tvStations.map(({ _id, name, countryId }) => ({
            value: _id,
            name,
            country: countryId
          }))
        ]
      },
      videoQualities: (state) => {
        return [
          ...state.videoQualities.videoQualities.map(({ _id, name }) => ({
            value: _id,
            name
          }))
        ]
      },
      channelFormItem() {
        const obj = { ...this.formItem }
        if (!obj.tvStation) {
          obj.tvStation = {
            _id: null
          }
        } else {
          if (obj.tvStation.countryId) {
            obj.countryId = obj.tvStation.countryId
          }
        }
        if (!obj._id) {
          obj.isHD = true
        }
        return obj
      },
      countries: state => state.countries.countries,
      currentLanguage: state => state.uiLanguages.currentLanguage
    }),
    translations() {
      return {
        imageUploading: this.$gettext('Nahrávání obrázku...'),
        imageType: this.$gettext('Obrázek musí mít příponu "png"'),
        maxSize: this.$gettext('Maximální velikost'),
        newTvChannel: this.$gettext('Nový TV kanál'),
        basicInfo: this.$gettext('Základní údaje'),
        uploadDefaultLogo: this.$gettext('Nahrát základní logo'),
        uploadColoredLogo: this.$gettext('Nahrát barevné logo'),
        upload720Logo: this.$gettext('Nahrát logo pro 720p'),
        upload1080Logo: this.$gettext('Nahrát logo pro 1080p'),
        logoDefault: this.$gettext('Základní logo'),
        logoColored: this.$gettext('Barevné logo'),
        logo720p: this.$gettext('720p logo'),
        logo1080p: this.$gettext('1080p logo'),
        name: this.$gettext('Název'),
        tvChannelId: this.$gettext('ID TV kanálu'),
        tvChannelCountry: this.$gettext('Stát TV kanálu'),
        tvStation: this.$gettext('TV Stanice'),
        sanitizedId: this.$gettext('Sanitizovaný tvar'),
        remoteId: this.$gettext('Vzdálené ID'),
        channelCharacter: this.$gettext('Charakter kanálu'),
        weight: this.$gettext('Váha'),
        broadcastingFrom: this.$gettext('Vysílání od'),
        broadcastingTo: this.$gettext('Vysílání do'),
        videoQuality: this.$gettext('Kvalita videa'),
        note: this.$gettext('Poznámka'),
        list: this.$gettext('Seznam'),
        active: this.$gettext('Aktivní')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('TV kanály'), link: { name: 'tv-channels' } },
        this.item.name || this.$gettext('Nový TV kanál')
      ]
    },
    dataPending() {
      return this.pending || this.imagesUploading
    },
    countrySelect() {
      return [{ name: 'Neurčeno', value: null }].concat(this.countries.map(v => ({ name: v.countryName, value: v._id })))
    },
    isTvStationCountryDefined() {
      return this.tvStationsOptions.find(v => v.value === this.tvStationId) &&
          this.tvStationsOptions.find(v => v.value === this.tvStationId).country !== null
    },
    imagesUploading() {
      return this.images.default.imagesUploading || this.images.colored.imagesUploading || this.images.p720.imagesUploading || this.images.p1080.imagesUploading
    }
  },
  methods: {
    ...mapActions([
      'getTvStations',
      'getTvStation',
      'getCountries',
      'getVideoQualities'
    ]),
    setImagesUploading(type, uploading) {
      this.images[type].imagesUploading = uploading
      setLoadingMessage(this, uploading ? this.translations.imageUploading : null)
    },
    setImageDeleting(type, deleting) {
      this.images[type].imageDeleting = deleting
    },
    setChannelLogoChanged(type, changed) {
      this.images[type].channelLogoChanged = changed
    },
    async onFormSubmit(e) {
      this.errors.clear()

      await this.$validator.validateAll()
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('TvChannel')
      const response = await commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }

      const { elements } = e.target
      const tvChannelId = response.data.data._id
      const fileLogoDefault = elements.namedItem('imgLogoDefault').files[0]
      const fileLogoColored = elements.namedItem('imgLogoColored').files[0]
      const fileLogo720p = elements.namedItem('imgLogo720p').files[0]
      const fileLogo1080p = elements.namedItem('imgLogo1080p').files[0]

      this.uploadImage(tvChannelId, 'default', fileLogoDefault)
      this.uploadImage(tvChannelId, 'colored', fileLogoColored)
      this.uploadImage(tvChannelId, 'p720', fileLogo720p)
      this.uploadImage(tvChannelId, 'p1080', fileLogo1080p)
    },
    async uploadImage(tvChannelId, type, fileLogo) {
      const imageApiUrl = VUE_APP_BASE_API_URL + 'channel-logo/'

      try {
        this.setImagesUploading(type, true)

        if (this.images[type].channelLogoChanged) {
          const formData = new FormData()
          let readyForUpload = true

          formData.set('type', type)

          if (fileLogo) {
            formData.set('fileExists', true)
            formData.set('type', type)
            formData.append('file', fileLogo)
            if (this.validate(fileLogo) !== '') {
              readyForUpload = false
              this.imageLogoLink = ''
              showErrorWithTimeout(this, this.validate(fileLogo))
            }
          } else {
            formData.set('fileExists', false)
            this.setImageDeleting(type, true)
          }
          if (readyForUpload) {
            formData.append('tvChannelId', tvChannelId)
            const vm = this
            const uploadResult = await axios.post(imageApiUrl, formData)
              .then(function (response) {
                if (response.status === 200 && response.data.message === 'deleted') {
                  vm.images[type].imageLogoLink = ''
                }
              })
          }
        }
      } finally {
        this.setImagesUploading(type, false)
        this.setImageDeleting(type, false)
        this.setChannelLogoChanged(type, false)
      }
    },
    validate(file) {
      const MAX_SIZE = 20000000
      const allowedTypes = ['image/png']

      if (!allowedTypes.includes(file.type)) {
        return this.translations.imageType
      }

      if (file.size > MAX_SIZE) {
        return `${this.translations.maxSize}: ${MAX_SIZE / 1000}Kb`
      }

      return ''
    },
    onFileChanged(type) {
      this.images[type].channelLogoChanged = true
      this.images[type].imageLogoLink = ''
    },
    getCountriesOrderedByName() {
      this.getCountries({
        params: {
          idLanguage: localStorage.ui_language_id,
          order: 'countryNames'
        }
      })
    },
    getTvStationsOrderedByName() {
      this.getTvStations({
        params: {
          order: 'name',
          limit: 100000
        }
      })
    },
    selectTvStation() {
      this.tvStationId = this.channelFormItem.tvStation._id
      if (this.tvStationId) {
        this.channelFormItem.countryId = this.tvStationsOptions.find(v => v.value === this.tvStationId).country
      } else {
        this.channelFormItem.countryId = null
      }
    }
  },
  watch: {
    formItem: {
      handler() {
        if (this.channelFormItem.channelLogoDefaultExists) {
          this.images['default'].imageLogoLink = this.channelFormItem.channelLogoDir + '/channel_logos/' + this.$route.params.id + '.png' + '?t=' + Date.now()
        }
        if (this.channelFormItem.channelLogoColoredExists) {
          this.images['colored'].imageLogoLink = this.channelFormItem.channelLogoDir + '/channel_logos/colored/' + this.$route.params.id + '.png' + '?t=' + Date.now()
        }
        if (this.channelFormItem.channelLogo720pExists) {
          this.images['p720'].imageLogoLink = this.channelFormItem.channelLogoDir + '/channel_logos/720p/' + this.$route.params.id + '.png' + '?t=' + Date.now()
        }
        if (this.channelFormItem.channelLogo1080pExists) {
          this.images['p1080'].imageLogoLink = this.channelFormItem.channelLogoDir + '/channel_logos/1080p/' + this.$route.params.id + '.png' + '?t=' + Date.now()
        }
        this.tvStationId = this.channelFormItem.tvStation._id
      }
    },
    currentLanguage() {
      this.getCountriesOrderedByName()
    }
  }
}
</script>
